import { IDemoFlow } from './types';

// Figma F6: an out-of-catalogue request keeps today's `unsupported` reply, with no action.

export const OUT_OF_SCOPE_REPLY = {
  outcome: 'unsupported' as const,
  answer: "This question is outside Orbit's supported Perx product scope."
};

export const OUT_OF_SCOPE_FLOWS: IDemoFlow[] = [
  {
    id: 'out-of-scope',
    prompt: 'Create a lucky draw campaign',
    reply: () => OUT_OF_SCOPE_REPLY
  }
];
